// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ExternalIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from external.svg
 */
export default function ExternalIcon(props: ExternalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ExternalIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M13 2a1 1 0 0 1 .993.883L14 3v6a1 1 0 0 1-1.993.117L12 9V5.414l-8.293 8.293a1 1 0 0 1-1.497-1.32l.083-.094L10.584 4H7a1 1 0 0 1-.993-.883L6 3a1 1 0 0 1 .883-.993L7 2z"
        />
      </g>
    </svg>
  );
}
